import React from "react";
import noop from "lodash/noop";
import { withTranslation } from "react-i18next";
import { S3 } from "../../constants";
import SvgIcon from "../SvgIcon";
import { RillContext } from "../../rill/RillReact/share/base";

class ImageWidgetUploadInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modified: false,
      src: undefined,
      backgroundedit: undefined,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleReset(e) {
    if (e && e.target && e.target.hasAttribute("data-noreset")) return;
    this.setState({
      src: undefined,
      modified: false,
      backgroundedit: undefined,
    });
  }

  handleChange({ target }) {
    if (!target.value) {
      return false;
    } else {
      // extract file
      const file = target.files[0];

      // setup file reader
      const fileReader = new FileReader();

      // store the image in state once it's loaded off the file system
      fileReader.onload = (event) => {
        this.setState({
          src: event.target.result,
          modified: true,
          backgroundedit: undefined,
        });
        if (this.props.handleImageUpload) {
          this.props.handleImageUpload(event.target.result);
        }
      };

      // handle the error...kind of.
      fileReader.onerror = (event) => {
        console.error(
          "File could not be read! Code " + event.target.error.code
        );
      };

      // finally read the file
      fileReader.readAsDataURL(file);
    }
  }

  componentWillMount() {
    const fullImagePath = this.props.defaultValue.file
      ? `/api/file/${this.props.defaultValue.file}`
      : this.props.defaultValue;
    this.setState({
      src: fullImagePath,
      backgroundedit: S3.toCDN(this.props.backgroundedit),
    });
  }

  render() {
    const { locals } = this.context;

    const {
      hasImage,
      handleImageUpload,
      showIcon = true,
      t,
      ...inputProps
    } = this.props;
    const { name } = inputProps;
    const { modified, src, backgroundedit } = this.state;
    const defaultValue = this.props.defaultValue.file;
    const imageBackground = backgroundedit
      ? backgroundedit
      : src || defaultValue;
    return (
      <div
        className={`image-input-wrapper ${
          hasImage || modified ? "image-widget-upload-container" : ""
        }`}
      >
        <label>
          <div
            className={hasImage ? "" : "empty-state"}
            style={{
              position: "relative",
              cursor: "pointer",
              backgroundImage: `url(${imageBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {!hasImage && !modified && (
              <>
                <p className="p4">{t("common:uploadImage")}</p>
                {showIcon && (
                  <SvgIcon src="/img/new-icons/add-square-outline.svg" />
                )}
                <p className="p6">{t("imageWidgetUpload.recommendedSize")}</p>
              </>
            )}
          </div>
          <input
            style={{ display: "none" }}
            key={defaultValue}
            ref="input"
            id="file-input"
            className="file-input"
            {...inputProps}
            type="file"
            accept="image/*"
            required={!defaultValue && this.props.required}
            onChange={this.handleChange}
            defaultValue={undefined}
          />
        </label>

        {!modified && defaultValue && (
          <input
            type="hidden"
            name={`${name}[file]`}
            value={defaultValue}
            onChange={noop}
          />
        )}
      </div>
    );
  }
}

ImageWidgetUploadInput.defaultProps = {
  defaultValue: {},
};

ImageWidgetUploadInput.contextType = RillContext;
export default withTranslation(["coaching-portal", "common"])(
  ImageWidgetUploadInput
);
